import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "./api";

const SiteCtx = createContext({ site: null, nav: [], loading: true });

export function SiteProvider({ children }) {
  const [site, setSite] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/site");
      setSite(data);
    } catch (e) {
      console.error("failed to load site settings", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <SiteCtx.Provider value={{ site, nav: site?.nav || [], loading, reload: load }}>
      {children}
    </SiteCtx.Provider>
  );
}

export function useSite() {
  return useContext(SiteCtx);
}
